<template>
  <dialog class="gp_dialog" ref="main">
    <!-- <div class="gp_dialog-backdrop" @mousedown.prevent="overlayClick" v-if="!noBackdrop"></div> -->
    <div class="gp_dialog-backdrop" @mousedown.prevent="overlayClick"></div>
    <div class="gp_dialog-container" :class="containerPadding">
      <section class="d-flex flex-column align-items-center justify-content-center">
        <div class="img-holder" v-if="item.type == 'success'">
          <svg xmlns="http://www.w3.org/2000/svg" width="57" height="57" viewBox="0 0 57 57">
            <g transform="translate(-732 -89)">
              <circle cx="28.5" cy="28.5" r="28.5" transform="translate(732 89)" fill="#d0fccf" />
              <g transform="translate(750 42.003)">
                <g transform="translate(0 67.997)">
                  <path d="M21.1,68.311a1.071,1.071,0,0,0-1.515,0L6.76,81.142,1.828,76.21A1.071,1.071,0,0,0,.313,77.725L6,83.414a1.071,1.071,0,0,0,1.515,0L21.1,69.826A1.071,1.071,0,0,0,21.1,68.311Z" transform="translate(0 -67.997)" fill="#148300" />
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div class="img-holder" v-if="item.type == 'error'">
          <svg xmlns="http://www.w3.org/2000/svg" width="57" height="57" viewBox="0 0 57 57">
            <g transform="translate(-732 -89)">
              <circle cx="28.5" cy="28.5" r="28.5" transform="translate(732 89)" fill="#ffecb9" />
              <g id="warning-sign" transform="translate(573.773 107)">
                <path d="M186.727,16.1a1.49,1.49,0,0,0,1.484-1.365l1.007-12.026a2.5,2.5,0,1,0-4.983,0l1.007,12.026A1.49,1.49,0,0,0,186.727,16.1Z" transform="translate(0)" fill="#ffba00" />
                <path d="M207.076,410.908a1.623,1.623,0,1,0,1.623,1.623A1.622,1.622,0,0,0,207.076,410.908Z" transform="translate(-20.348 -393.923)" fill="#ffba00" />
              </g>
            </g>
          </svg>
        </div>
        <div class="dialog-message d-flex flex-column align-items-center justify-content-center">
          <div class="typo-heading20 typo-semibold text-light-high text-center" v-html="$t(item.message, item.data)"></div>
          <button class="btn btn-primary btn-default px-4 mt-2" @click.prevent="closeDialog">OK</button>
        </div>
      </section>
    </div>
  </dialog>
</template>

<script>
export default {
  name: "GDialog",
  props: {
    item: Object
  },
  computed: {
    containerPadding() {
      if (typeof this?.item?.containerPadding == "string") {
        return this.item.containerPadding;
      }
      return "p-4";
    }
  },
  methods: {
    overlayClick() {},
    closeDialog() {
      this.$emit("close", this.item.id);
    }
  }
};
</script>

<style lang="scss" scoped>
$baseIndex: $modalIndex;
.gp_dialog {
  position: fixed;
  z-index: $baseIndex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  @include flex-center;

  &-backdrop {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    background: rgba(#000, 0.5);
  }

  &-container {
    position: relative;
    background: $bg;
    width: 100%;
    max-width: 560px;
    max-height: 100%;
    display: flex;
    z-index: 10;
    flex-direction: column;
    border-radius: $radius;
  }
}
</style>
